import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChild, forwardRef, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ControlContainer, NG_VALUE_ACCESSOR } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { BaseFpxControlComponent } from "@fpx/core"; 
import { SlickCarouselComponent } from "ngx-slick-carousel";
import { map } from "rxjs";
import { FormControlTemplatesService } from "src/app/templates/form-control-templates.service";

@Component({
  selector: "fpx-carousel",
  templateUrl: "./fpx-carousel.component.html",
  styleUrls: ["./fpx-carousel.component.scss"],
  providers : [
    {
      provide : NG_VALUE_ACCESSOR,
      useExisting : forwardRef(() => FpxCarouselComponent),
      multi : true
    }
  ],
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class FpxCarouselComponent extends BaseFpxControlComponent {
  @ViewChild('slickModal') slickModal: SlickCarouselComponent;
  @ContentChild(TemplateRef) template!: TemplateRef<any>;
  slideConfig = {
    "slidesToShow": 1,
    "slidesToScroll": 1,
    dots: true,
    arrows: false,
    infinite: false,
    centerMode: true,
    variableWidth: true,
};
  expandMode: boolean = false;
  selectableList: any[];
  constructor(
    controlContainer: ControlContainer,
    changeDetectorRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private _fromControlTemplateService:FormControlTemplatesService
  ) {
    super(controlContainer, changeDetectorRef);
    Window["FpxCarouselComponent"] = this;
  }

  

  addSlide() {
    // this.slides.push({img: "http://placehold.it/350x150/777777"})
  }
  
  removeSlide() {
    // this.slides.length = this.slides.length - 1;
  }
  
  slickInit(e:any) {
    console.log('slick initialized',e);
    Array.from(document.getElementsByClassName('slick-slide')).forEach((element: any, i) => {
      var classArray = [...element.classList];
      if(classArray.indexOf('slide-checked') != -1) {
        setTimeout(() => {
          this.slickModal.slickGoTo(i);
        }, 500); 
      }
    });
  }
  
  breakpoint(e:any) {
    console.log('breakpoint',e);
  }
  
  afterChange(e:any) { 
    this.onChange(e.currentSlide);
    this.onTouched();
  }
  
  beforeChange(e:any) {
    console.log('beforeChange',e);
  }

  showModel(i) {
    this.expandMode = !this.expandMode;
    if(this.expandMode) {
      document.querySelector('app-cob-product-selection-form form').classList.add('expand-mode');
      document.getElementsByClassName('slick-slide')[i].classList.add('view-more');
    }
    else {
      document.querySelector('app-cob-product-selection-form form').classList.remove('expand-mode');
      document.getElementsByClassName('slick-slide')[i].classList.remove('view-more');
    }
  }

  onClickCard($event, slideIndex, id) {
    this.slickModal.slickGoTo(slideIndex);
    this.formControl.setValue(id, { onlySelf: true, emitEvent: false });
    this.formControl.updateValueAndValidity()
  }

}
